import { NgModule } from '@angular/core';
import { RejectedHintComponent } from './rejected-hint.component';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CertificatesService } from 'services/professional/certificates/certificates.service';
import { StepService } from 'services/professional/step/step.service';
import { RejectedHintModalComponent } from './rejected-hint-modal/rejected-hint-modal.component';
import { SmartModalModule } from '@certemy/ui-components';

@NgModule({
  imports: [CertemyCommonModule, NgbTooltipModule, SmartModalModule.forRoot()],
  exports: [RejectedHintComponent],
  declarations: [RejectedHintComponent, RejectedHintModalComponent],
  providers: [CertificatesService, StepService, NgbModal],
})
export class RejectedHintModule {}
